import './App.css';
import "slick-carousel/slick/slick.css";
import { Toaster } from 'react-hot-toast';
import "slick-carousel/slick/slick-theme.css";
import AppRoutes from "./routes/AppRoutes";
import Header from "./components/include/Header";
import Footer from "./components/include/Footer";
import ScrollAndSal from "./components/util/ScrollAndSal";
import ContactSection from "./components/include/ContactSection";
// import DnaLoader from './components/loader/DnaLoader';
// import { useEffect, useState } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { AppointmentProvider } from './context/AppointmentContext';
import { HelmetProvider } from 'react-helmet-async';
import MobileCTA from './components/home/partials/MobileCTA';

function AppContent() {
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 200);
  //   return () => clearTimeout(timer);
  // }, []);

  // if (loading) {
  //   return <DnaLoader />;
  // }

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Header />
      <ScrollAndSal>
        <main>
          <AppRoutes />
        </main>
        <ContactSection />
        <Footer />
        <MobileCTA />
      </ScrollAndSal>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppointmentProvider>
          <AppContent />
        </AppointmentProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;